// extracted by mini-css-extract-plugin
export default {"trainee_data":"style_trainee_data__4Z9hX"};